import { createContext } from 'react';

export type ThemeValue = 'dark' | 'light';

export const ThemeContext = createContext<{
  theme: ThemeValue;
  setTheme?: (theme: ThemeValue) => void;
}>({ theme: 'light', setTheme: undefined });
